import { useQuery } from "@tanstack/react-query";

import { getOrganizationProperties } from "api/tenants";

import { PaginationTable } from "js/components/types";

import { queryKeys } from "./queryKeys";

interface UseGetOrganizationPropertiesOptions {
  pagination: PaginationTable;
  enabled?: boolean;
}

export const useGetOrganizationProperties = (
  options: UseGetOrganizationPropertiesOptions,
) => {
  const { pagination, enabled = true } = options;

  return useQuery({
    queryKey: [
      ...queryKeys.properties.organization(),
      pagination.current,
      pagination.pageSize,
    ],
    queryFn: () => getOrganizationProperties(pagination),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
